import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class PaginationService {
  private paginationSubject = new BehaviorSubject<{ page: number, pageSize: number, query?: string }>({ page: 0, pageSize: 10, query: undefined });
  pagination$ = this.paginationSubject.asObservable();

  constructor(private router: Router, private route: ActivatedRoute) {}

  updatePagination(event: { page?: number, pageSize?: number, query?: string }) {
    const current = this.paginationSubject.value;

    const updated = {
        page: event.page ?? current.page,
        pageSize: event.pageSize ?? current.pageSize,
        query: 'query' in event ? event.query : current.query
      };      

    this.paginationSubject.next(updated);

    this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { 
          page: updated.page,
          pageSize: updated.pageSize,
          searchQuery: updated.query
        },
        queryParamsHandling: 'merge'
      });
  }

  setPagination(p: { page?: number, pageSize?: number, query?: string }) {
    const current = this.paginationSubject.value;
    const updated = {
      page: p.page ?? current.page,
      pageSize: p.pageSize ?? current.pageSize,
      query: p.query ?? current.query
    };
    this.paginationSubject.next(updated);
  }
  
}
